import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import styles from './styles.module.scss';

const Subheader = (props) => (
  <span {...props} className={cn(styles.subheader, props.className)} />
);

Subheader.propTypes = {
  className: PropTypes.string,
};

Subheader.defaultProps = {
  className: '',
};

export default Subheader;
